import { CustomField } from '../types/Product/CustomField';

const formatCustomFields = (customFields: CustomField[]): string => {
  let formattedCustomFields: string[] = [];
  customFields.map((customField) => formattedCustomFields.push(`${customField.fieldLabel}: ${customField.fieldValue}`));
  return formattedCustomFields.join(', ');
};

export { formatCustomFields };
